export enum EElementsVisibilitySummaryView {
  Multiline = 'Multiline',
  TwoColumns = 'TwoColumns',
}

export interface IElementsVisibilityState {
  publicationWrapper: {
    isVisibleWithoutPackages: boolean;
  };
  promotionWrapper: {
    isMoneySourceWidgetVisible: boolean;
  };
  summary: {
    view: EElementsVisibilitySummaryView;
    isMoneySourceWidgetVisible: boolean;
  };
  experiments?: {
    allowDisablePromotionSection?: boolean;
    hidePromotionToggle?: boolean;
  };
}
